import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Viimeaikainen toiminta',
  actions: {
    clicked: 'Klikattu',
    open: 'Avattu',
    scheduled: 'Ajoitettu',
    sent: 'Lähetetty',
  },
  fields: {
    recipients: '{{recipients}} vastaanottajaa',
    opened: '{{rate}} avattu',
    clicked: '{{rate}} klikattu',
    awaiting: 'Odottaa vahvistusta',
  },
  template_types: TemplateNames,
};
